import type { GroupPermission as GroupPermissionModel } from '@/adapters/catalogv1.g';

export function extractGroupPermission(model: GroupPermissionModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    groupRef: model.group_ref ?? '',
    permissionRef: model.permission_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogGroupPermission = ReturnType<typeof extractGroupPermission>;
